// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".onboarding-block[data-v-763fc5d0] {\n  padding: 0 23px 23px;\n}\n.onboarding-block .onboarding-block-wrap[data-v-763fc5d0] {\n  padding-top: 35px;\n  background: #fff;\n  border-radius: 8px;\n  -webkit-box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05);\n          box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.05);\n}\n.onboarding-block h3[data-v-763fc5d0] {\n  font-size: 32px;\n  line-height: 40px;\n  font-weight: 600;\n  text-align: center;\n  margin: 0 0 62px;\n}", ""]);
// Exports
module.exports = exports;
